import { Types } from "../types";
export var searchFilterFragmentSchema = Types.enum(["", "search all", "search calendar", "search competitions", "search competitors", "search events", "search features"]);
//# sourceMappingURL=searchFilterFragment.js.map